export default [

    {
        path: '',
        name: 'cartas-de-planejamento',
        redirect: { name: 'cartas-de-planejamento-home' },
    },

    {
        path: 'home',
        name: 'cartas-de-planejamento-home',
        component: () => import('@/aplicacao/modulos/cartas-de-planejamento/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_CARTAS_DE_PLANEJAMENTO' },
    },

    {
        path: 'visualizacao/:data',
        name: 'cartas-de-planejamento-visualizacao',
        component: () => import('@/aplicacao/modulos/cartas-de-planejamento/Visualizacao'),
        meta: { autenticacao: true, permissao: 'ROLE_CARTAS_DE_PLANEJAMENTO_VISUALIZAR' },
    },

]
